import axios from 'axios';

// search vat percent api
export async function getVatPercentAPI() {
	let vatPercent = [];
	// const percentage = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/fixedValues/getVatPercent`,
			// data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		vatPercent = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return vatPercent;
}

//update vat percent api
export async function updateVatPercentAPI(Data, userID) {
	let vatPercent = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/fixedValues/update/vatPercent`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		vatPercent = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return vatPercent;
}

// search timeout api
export async function getTimeoutAPI() {
	let timeout = [];
	// const percentage = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/fixedValues/getTimeout`,
			// data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		timeout = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return timeout;
}

//update timeout api
export async function updateTimeoutAPI(Data, userID) {
	let timeout = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/fixedValues/update/timeout`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		timeout = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return timeout;
}